/* @flow */
import React, { Component } from 'react';
import { css, names } from 'linaria';

import withBreakpoint from '../withBreakpoint';
import { responsiveStyles } from '../../constants/Responsive';
import type { ResponsiveValue } from '../../constants/Responsive';
import { RESPONSIVE_SPACER_SIZE_STYLES } from '../../constants/ResponsiveSpacer';

class Spacer extends Component<{
  size: number | ResponsiveValue<$Keys<typeof RESPONSIVE_SPACER_SIZE_STYLES>>,
  color?: string,
  breakpoint: BreakpointSize,
}> {
  static defaultProps = { size: 0 };

  getInlineStyles() {
    const { size, breakpoint } = this.props;
    if (typeof size === 'number') {
      if (breakpoint === 'small') return { padding: `${(size / 2) * 0.5}px 0` };
      else if (breakpoint === 'medium') return { padding: `${(size / 2) * 0.75}px 0` };
      else return { padding: `${size / 2}px 0` };
    } else return {};
  }

  getResponsiveStyles() {
    const { size } = this.props;
    return [
      typeof size !== 'number' && responsiveStyles(size, k => RESPONSIVE_SPACER_SIZE_STYLES[k]),
    ];
  }

  renderHairline() {
    const { color } = this.props;
    if (!color) {
      return null;
    }

    return (
      <hr
        style={{
          outline: 'none',
          borderColor: color,
          borderStyle: 'solid',
          borderWidth: '0 0 1px',
        }}
      />
    );
  }

  render() {
    return (
      <div
        style={this.getInlineStyles()}
        className={names(...[...this.getResponsiveStyles(), ContainerStyles])}>
        {this.renderHairline()}
      </div>
    );
  }
}

export default withBreakpoint(Spacer);

const ContainerStyles = css`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/ui/components/core/Spacer.js